import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dir-panel" }
const _hoisted_2 = { class: "dir-cab" }
const _hoisted_3 = { class: "dir-conteo" }
const _hoisted_4 = {
  key: 0,
  class: "dir-info"
}
const _hoisted_5 = {
  key: 1,
  class: "dir-vacio"
}
const _hoisted_6 = {
  key: 2,
  class: "dir-tabla"
}
const _hoisted_7 = {
  key: 0,
  class: "dir-badge"
}
const _hoisted_8 = { class: "dir-acciones" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 3,
  class: "dir-form"
}
const _hoisted_12 = { class: "dir-grid" }
const _hoisted_13 = { class: "dir-form-acciones" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "dir-error"
}

import { ref, computed, watch, onMounted } from 'vue'
import {
  getDirectivosService,
  agregarDirectivoService,
  actualizarDirectivoService,
  eliminarDirectivoService,
  type Directivo
} from '@/services/InstitucionSniesService'


export default /*@__PURE__*/_defineComponent({
  __name: 'DirectivosPanel',
  props: {
    idArea: {}
  },
  setup(__props: any) {

/**
 * Directivos de una dependencia.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const directivos = ref<Directivo[]>([])
const cargando = ref(false)
const guardando = ref(false)
const editando = ref<Partial<Directivo> | null>(null)
const error = ref('')

// Los que ya salieron se conservan: quién firmaba en cada momento es parte de
// la trazabilidad de los actos administrativos.
const vigentes = computed(() => directivos.value.filter(d => d.vigente))
const salientes = computed(() => directivos.value.filter(d => !d.vigente))

async function cargar() {
  cargando.value = true
  try {
    directivos.value = await getDirectivosService(props.idArea)
  } finally {
    cargando.value = false
  }
}

function abrirNuevo() {
  error.value = ''
  editando.value = { cargo: '', nombre: '', apellido: '', acto_nombramiento: '' }
}

function abrirEditar(d: Directivo) {
  error.value = ''
  editando.value = { ...d }
}

async function guardar() {
  if (!editando.value?.cargo || !editando.value?.nombre) return
  guardando.value = true
  error.value = ''
  try {
    const resultado = editando.value.id_directivo
      ? await actualizarDirectivoService(editando.value.id_directivo, editando.value)
      : await agregarDirectivoService(props.idArea, editando.value)

    if (!resultado.ok) {
      error.value = resultado.error ?? 'No se pudo guardar'
      return
    }
    editando.value = null
    await cargar()
  } finally {
    guardando.value = false
  }
}

async function eliminar(d: Directivo) {
  if (await eliminarDirectivoService(d.id_directivo)) await cargar()
}

watch(() => props.idArea, () => { editando.value = null; cargar() })
onMounted(cargar)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Directivos", -1)),
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(vigentes.value.length) + " vigente" + _toDisplayString(vigentes.value.length === 1 ? '' : 's') + " ", 1),
        (salientes.value.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" · " + _toDisplayString(salientes.value.length) + " anterior(es)", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        class: "btn-dir-nuevo",
        onClick: abrirNuevo
      }, "+ Directivo")
    ]),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Cargando directivos…"))
      : (!directivos.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Esta dependencia no tiene directivos registrados. "))
        : (_openBlock(), _createElementBlock("table", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Cargo"),
                _createElementVNode("th", null, "Nombre"),
                _createElementVNode("th", null, "Acto"),
                _createElementVNode("th", null, "Desde"),
                _createElementVNode("th", null, "Hasta"),
                _createElementVNode("th")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directivos.value, (d) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: d.id_directivo,
                  class: _normalizeClass({ saliente: !d.vigente })
                }, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(d.cargo) + " ", 1),
                    (!d.vigente)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "anterior"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(d.nombre_completo), 1),
                  _createElementVNode("td", null, _toDisplayString(d.acto_nombramiento ?? '—'), 1),
                  _createElementVNode("td", null, _toDisplayString(d.fecha_desde ?? '—'), 1),
                  _createElementVNode("td", null, _toDisplayString(d.fecha_hasta ?? 'en el cargo'), 1),
                  _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "btn-dir",
                      onClick: ($event: any) => (abrirEditar(d))
                    }, "Editar", 8, _hoisted_9),
                    _createElementVNode("button", {
                      class: "btn-dir btn-dir-peligro",
                      onClick: ($event: any) => (eliminar(d))
                    }, "Eliminar", 8, _hoisted_10)
                  ])
                ], 2))
              }), 128))
            ])
          ])),
    (editando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("h5", null, _toDisplayString(editando.value.id_directivo ? 'Editar directivo' : 'Nuevo directivo'), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", null, [
              _cache[11] || (_cache[11] = _createTextVNode("Cargo *")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editando.value.cargo) = $event)),
                class: "dir-input",
                placeholder: "Rector"
              }, null, 512), [
                [_vModelText, editando.value.cargo]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[12] || (_cache[12] = _createTextVNode("Nombre *")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editando.value.nombre) = $event)),
                class: "dir-input"
              }, null, 512), [
                [_vModelText, editando.value.nombre]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[13] || (_cache[13] = _createTextVNode("Apellido")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editando.value.apellido) = $event)),
                class: "dir-input"
              }, null, 512), [
                [_vModelText, editando.value.apellido]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[14] || (_cache[14] = _createTextVNode("Acto de nombramiento ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editando.value.acto_nombramiento) = $event)),
                class: "dir-input",
                placeholder: "Acta 01, Sala General"
              }, null, 512), [
                [_vModelText, editando.value.acto_nombramiento]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[15] || (_cache[15] = _createTextVNode("Fecha de la norma")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editando.value.fecha_norma) = $event)),
                type: "date",
                class: "dir-input"
              }, null, 512), [
                [_vModelText, editando.value.fecha_norma]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[16] || (_cache[16] = _createTextVNode("Desde")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editando.value.fecha_desde) = $event)),
                type: "date",
                class: "dir-input"
              }, null, 512), [
                [_vModelText, editando.value.fecha_desde]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[17] || (_cache[17] = _createTextVNode(" Hasta ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editando.value.fecha_hasta) = $event)),
                type: "date",
                class: "dir-input"
              }, null, 512), [
                [_vModelText, editando.value.fecha_hasta]
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("small", { class: "dir-ayuda" }, "Vacío = sigue en el cargo", -1))
            ]),
            _createElementVNode("label", null, [
              _cache[19] || (_cache[19] = _createTextVNode("Correo")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editando.value.email) = $event)),
                type: "email",
                class: "dir-input"
              }, null, 512), [
                [_vModelText, editando.value.email]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn-dir",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (editando.value = null))
            }, "Cancelar"),
            _createElementVNode("button", {
              class: "btn-dir btn-dir-ok",
              disabled: !editando.value.cargo || !editando.value.nombre || guardando.value,
              onClick: guardar
            }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_14)
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})